import { render, staticRenderFns } from "./imgOrVideoDetail.vue?vue&type=template&id=2bfd6337&scoped=true"
import script from "./imgOrVideoDetail.vue?vue&type=script&lang=js"
export * from "./imgOrVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./imgOrVideoDetail.vue?vue&type=style&index=0&id=2bfd6337&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd6337",
  null
  
)

export default component.exports